/*
 * File: CustomCard.tsx
 * Project: a-a
 * File Created: Wednesday, 6th November 2024 8:50:29 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 17th July 2025 7:37:38 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import { Box, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

const CustomCard = ({
  styles,
  className,
  children,
}: {
  styles: SxProps<Theme>;
  children: ReactNode;
  className?: string;
}) => {
  return (
    <Box sx={{ ...styles }} className={className}>
      {children}
    </Box>
  );
};

export default CustomCard;
